import React from 'react';
import { Button, cn } from '@strivelabs/ui-core';
import { MessageCircle } from 'lucide-react';

export interface ChatCTABlockProps {
  /**
   * Banner text shown to the left of the button. When omitted, the component
   * renders the button alone (right-aligned), matching the action-button style
   * used inside `ContentListCard` items.
   */
  context?: string;
  buttonText?: string;
  onChatClick: () => void;
  className?: string;
}

export const ChatCTABlock: React.FC<ChatCTABlockProps> = ({
  context,
  buttonText = 'Chat Now',
  onChatClick,
  className,
}) => {
  // Button-only mode — no banner, right-aligned button matching content-list
  // item action styling (Button variant="gradient" size="xs").
  if (!context) {
    return (
      <div className={cn('flex items-center justify-end gap-2', className)}>
        <Button
          onClick={onChatClick}
          variant="gradient"
          size="xs"
        >
          <MessageCircle className="mr-1.5 h-3.5 w-3.5" />
          {buttonText}
        </Button>
      </div>
    );
  }

  return (
    <div className={cn('rounded-xl border-[0.5px] border-custom overflow-hidden', className)}>
      <div className="relative min-h-[43px] px-4 py-3 flex items-center justify-between gap-3 overflow-hidden before:absolute before:inset-0 before:bg-gradient-action before:opacity-[0.05] before:z-0">
        <p className="relative z-10 text-sm text-gray-700">
          {context}
        </p>
        <Button
          onClick={onChatClick}
          variant="gradient"
          className="relative z-10 shrink-0 h-[32px] px-5 whitespace-nowrap text-xs shadow-sm hover:shadow-md transition-shadow border border-orange-200 text-orange-800"
        >
          <MessageCircle className="mr-1.5 h-3.5 w-3.5" />
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
